import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function PoliticaPrivacidad() {
  return (
    <LegalLayout eyebrow="Legal" title="Política de privacidad" updated="septiembre de 2026" testid="legal-page-privacidad">
      <LegalSection title="1. Responsable del tratamiento">
        <p>
          Responsable: <strong className="font-semibold text-slate-900">PisoScore Technologies S.L.</strong> (CIF
          [pendiente de asignar]), con domicilio en [Domicilio social], Madrid, España. Contacto:{" "}
          <a href="mailto:hola@pisoscore.es" className="font-medium text-emerald-600 hover:text-emerald-700">
            hola@pisoscore.es
          </a>
          .
        </p>
        <p>
          Esta política cumple el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018, de 5 de diciembre, de
          Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD).
        </p>
      </LegalSection>

      <LegalSection title="2. Qué datos tratamos">
        <p>
          <strong className="font-semibold text-slate-900">Análisis inmobiliarios:</strong> la calculadora funciona
          íntegramente en tu navegador. Si pulsas «Guardar análisis», almacenamos únicamente los valores numéricos
          introducidos (precio, alquiler, financiación, gastos y comunidad autónoma) y los resultados calculados, de
          forma <strong className="font-semibold text-slate-900">anónima</strong>: sin nombre, sin correo, sin cuenta
          de usuario y sin identificadores que permitan relacionarte con el análisis.
        </p>
        <p>
          <strong className="font-semibold text-slate-900">Comunicaciones:</strong> si nos escribes a
          hola@pisoscore.es, trataremos tu dirección de correo y el contenido del mensaje para responder a tu
          consulta.
        </p>
        <p>
          <strong className="font-semibold text-slate-900">Datos técnicos:</strong> dirección IP, tipo de navegador y
          páginas visitadas, recogidos por los registros técnicos del servidor con fines de seguridad y mejora del
          servicio.
        </p>
      </LegalSection>

      <LegalSection title="3. Finalidad y base jurídica">
        <p>
          Estadísticas agregadas y anónimas sobre el uso de la herramienta (art. 6.1.f RGPD, interés legítimo);
          atención de consultas recibidas por correo (art. 6.1.b RGPD, medidas precontractuales); y seguridad del
          servicio (art. 6.1.f RGPD).
        </p>
      </LegalSection>

      <LegalSection title="4. Plazo de conservación">
        <p>
          Los análisis anónimos se conservan de forma indefinida al no contener datos personales. Los correos de
          contacto se conservan el tiempo necesario para atender la consulta y, como máximo, 12 meses. Los registros
          técnicos, un máximo de 12 meses.
        </p>
      </LegalSection>

      <LegalSection title="5. Destinatarios y encargados de tratamiento">
        <p>
          No cedemos datos personales a terceros. Los proveedores de alojamiento e infraestructura actúan como
          encargados de tratamiento conforme al art. 28 RGPD, con servidores ubicados en la Unión Europea.
        </p>
      </LegalSection>

      <LegalSection title="6. Tus derechos">
        <p>
          Puedes ejercer los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y
          portabilidad escribiendo a{" "}
          <a href="mailto:hola@pisoscore.es" className="font-medium text-emerald-600 hover:text-emerald-700">
            hola@pisoscore.es
          </a>
          , acreditando tu identidad. Si consideras que el tratamiento no se ajusta a la normativa, puedes presentar
          una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).
        </p>
      </LegalSection>

      <LegalSection title="7. Cookies">
        <p>
          Este Sitio Web no utiliza cookies publicitarias ni de terceros con fines de perfilado. Únicamente pueden
          emplearse cookies o almacenamiento local de carácter técnico, necesarios para el funcionamiento de la
          herramienta, que no requieren consentimiento conforme a la LSSI-CE.
        </p>
      </LegalSection>

      <LegalSection title="8. Seguridad">
        <p>
          Aplicamos medidas técnicas y organizativas apropiadas al riesgo, incluyendo cifrado de las comunicaciones
          mediante HTTPS y control de acceso a los sistemas, para proteger la información tratada.
        </p>
      </LegalSection>

      <LegalSection title="9. Cambios en esta política">
        <p>
          Podemos actualizar esta política para adaptarla a cambios normativos o del servicio. La versión vigente
          será la publicada en esta página, con su fecha de última actualización.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
